import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  useDataModel
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { SponsoredUniversalBanner } from '../components/SponsoredUniversalBanner';

const SponsoredBannerComposable = ({ renderDefaultBanner, bannerType, schema, shouldPreload } ) => {
  const ctx = useContext(ExperienceContext);
  const { customContext } = ctx;
  const { isHybridLayout} = customContext;
  const variables = customContext?.variables || {}; // Get global search variables from custom context
  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables.navParam && !variables.keyword,
  };
  const { data } = useDataModel('searchModel', defaultOptions) || {};

  return (
    <div className={isHybridLayout && 'sui-ml-2'}>
      <SponsoredUniversalBanner
        bannerType={bannerType}
        renderDefaultBanner={renderDefaultBanner}
        shouldPreload={shouldPreload}
        schema={schema}
        pageContext={{
          data,
          keyword: variables?.keyword || '',
        }}
      />
    </div>
  );
};

const propTypes = {
  renderDefaultBanner: PropTypes.bool,
  bannerType: PropTypes.string,
  schema: PropTypes.string.isRequired,
  shouldPreload: PropTypes.bool,
};

const defaultProps = {
  renderDefaultBanner: false,
  bannerType: '',
  shouldPreload: true,
};

SponsoredBannerComposable.propTypes = propTypes;
SponsoredBannerComposable.defaultProps = defaultProps;
SponsoredBannerComposable.displayName = 'SponsoredBannerComposable';
SponsoredBannerComposable.dataModel = SponsoredUniversalBanner.dataModel;

export { SponsoredBannerComposable };
